import EmbedSocial from "../../components/general/EmbedSocial";
import GridItem from "../../components/general/GridItem";
import { useAppState } from "../../context/app/context";

const EmbedSocialModule = () => {
	const { siteConfig } = useAppState();
	const dataRef = siteConfig.embed_social_key;
	return (
		<GridItem>
			<EmbedSocial dataRef={dataRef} />
		</GridItem>
	);
};
export default EmbedSocialModule;
